module.exports = __webpack_public_path__ + "img/mycelium-logo.a5c7a0c3.svg";